import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_accessibility from 'highcharts/modules/accessibility';
import HC_stock from 'highcharts/modules/stock';
import { Options, SeriesOptionsType } from 'highcharts';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadMercadoCambiario } from '../../shared/utilities/utilidad-mercado-cambiario';
import { ActivatedRoute } from '@angular/router';
import { MercadoCambiario } from '../../shared/entities/mercado-cambiario';
import { formatNumber } from '@angular/common';

HC_exporting(Highcharts);
HC_exportData(Highcharts);
HC_accessibility(Highcharts);
HC_stock(Highcharts);

@Component({
  selector: 'app-mercado-cambiario',
  templateUrl: './mercado-cambiario.component.html',
  styleUrls: ['./mercado-cambiario.component.css']
})
export class MercadoCambiarioComponent implements OnInit {

  public Highcharts: typeof Highcharts = Highcharts;
  private util: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();

  public mcChartOptions: Highcharts.Options = {
    chart:{
      events: this.util.chartEventsOptions(),
    },
    series:[{
      type: 'line',
      data: []
    }]
  };

  public updateFlag: boolean = true;

  public interval:any;

  public festivoUSA:string='';

  public isHabilidato = true;

  public mercadoCambiario:MercadoCambiario = new MercadoCambiario();
  public isTablaMercadoCambiario = false;

  constructor(private service: VisualizadorService, private route: ActivatedRoute, private location: Location) {
    
  }

  ngOnInit(): void {
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Mercado interbancario de divisas - intradía - datos en tiempo real','Comportamiento del mercado del dólar durante el día (información en tiempo real)','intradía, mercado, divisas, dólar, tiempo real',currentUrl);

    this.service.setWindowScroll(0, 0);
    this.route.url.subscribe(url => {
      console.log(url);
      if(url.length > 0 && url[0].path === 'dashboard' || url.length > 0 && url[0].path === 'informacionSerie'){
        this.isHabilidato = false;
      }else{
        this.isHabilidato = true;
      }
    });

    this.consultaTablaMercadoCambiario();
    this.service.getFestivoUSA().subscribe({
      next: (data) => {
        this.festivoUSA = data;
      },
      error: (error) => {
        console.log("Error inesperado en getFestivoUSA", error);
      }
    });
    this.service.getMercadoCambiario().subscribe({
      next: (data) => {
        this.initChart(data);
      },
      error: (error) => {
        console.log("Error inesperado en generaListaOptions.getInformacionSeriesAutocomplete", error);
      }
    });
    this.iniciarConsultaDatosTiempoReal();

  }

  public iniciarConsultaDatosTiempoReal(){
    setInterval(() => {      
      this.consultaTablaMercadoCambiario();
      this.service.getMercadoCambiario().subscribe({
        next: (data) => {
          let listaOptionType: Array<Highcharts.SeriesOptionsType> = new Array();
          const ns = this.getSerieChart(data);
          listaOptionType.push(ns);
          this.mcChartOptions = {
            series: listaOptionType,
            subtitle: {
              text: this.generaTitulo()
            }
          }
        },
        error: (error) => {
          console.log("Error inesperado en generaListaOptions.getInformacionSeriesAutocomplete", error);
        }
      });
    },9000)
  }

  private consultaTablaMercadoCambiario(){
    this.service.getTablaMercadoCambiario().subscribe({
      next: (data) => {
        this.mercadoCambiario = data;
        var precioCierre = data.precioCierre;
        var precioPromedio = data.precioPromedio.toString();
        var precioApertura  = data.precioApertura;
        var montoTotal = data.montoTotal;
        this.mercadoCambiario.precioCierre=formatNumber(Number(precioCierre), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.precioPromedio=formatNumber(Number(precioPromedio), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.precioApertura=formatNumber(Number(precioApertura), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.montoTotal=formatNumber(Number(montoTotal), 'co-ES', '1.' + 3 + '-' + 3);
        this.isTablaMercadoCambiario = true;
      },
      error: (error) => {
        console.log("Error inesperado en generaListaOptions.getTablaMercadoCambiario", error);
      }
    });
  }

  public initChart(data: any[]) {
    let listaSerieChart: Array<Highcharts.SeriesOptionsType> = new Array();
    const ns = this.getSerieChart(data);
    listaSerieChart.push(ns);
    this.mcChartOptions = this.getHighchartsOptions(listaSerieChart);
  }

  public getHighchartsOptions(listaSeriesChart: any[]): Options {
    return {
      chart: {
        borderColor: '#ececec',
        borderWidth: 1,
        events: this.util.chartEventsOptions(),
        marginBottom: 200,
        style: {
          fontFamily: 'Arial'
        }
      },
      title: {
        text: 'Evolución intradía del precio promedio negociado del dólar estadounidense',
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#004677'
        }
      },
      subtitle: {
        text: this.generaTitulo(),
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#000000'
        }
      },
      credits: {
        enabled: false,
        text: ''
      },
      legend: {
        layout: 'horizontal',
        align: 'left',
        verticalAlign: 'top'
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 1
        }
      },
      // PROPIEDADES DEL EJE x
      xAxis: this.util.xAxisOptions(),
      // PROPIEDADES DEL EJE Y
      yAxis: this.util.yAxisOptions(),
      tooltip: {
        formatter: function () {
          var fecha = new Date(Number(this.x));
          return this.points!.reduce(function (s, point) {
            return s + '<br/>' + 'Precio promedio ponderado: '
              + point.y!;
          }, 'Hora de la Transacción: '
          + fecha.toLocaleTimeString());
        },
        valueDecimals: 2,
        shared: true,
        borderWidth: 3,
        style: {
          padding: '30px'
        }
      },
      series: listaSeriesChart,
      navigation: {
        buttonOptions: {
          theme: {
            // Good old text links
            /*style: {
              color: '#039',
              textDecoration: 'underline'
            }*/
          }
        },
        menuItemHoverStyle: {
          background: '#ebeced',
          color: 'black'
        }
      },
      exporting: this.util.exportingOptions(),
      lang: this.util.langOptions(),
      responsive: {
        rules: [{
          condition: {
            maxWidth: 1000,
            minHeight: 800,
            minWidth: 300
          }
        }]
      }
    }
  }

  private generaTitulo():string{
    let mc: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();
    var response:string='';
    response =mc.getTituloActualizado(this.festivoUSA);
    return response;
  }

  private getSerieChart(data: any[]): any {
    let mc: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();
    const datosConvertidos = data.map(item => {
      return [Number(item[0]), Number(item[1])];
    })
    let nombre:string = mc.getDatosSerieJson(data[0][0]);
    let serieChart: SeriesOptionsType = {
      name: nombre,
      color: '#008000',
      type: 'line',
      data: data
    };
    return serieChart;
  }
}
